<template>
  <div class="auth">
    <div class="auth-card">
      <div class="auth-header">
        <h1 class="auth-title">Вход</h1>
        <p class="auth-subtitle">Войдите в систему <b>Master CRM</b>, чтобы начать работу</p>
      </div>

      <form
        class="auth-form"
        @submit.prevent="submit"
      >
        <div class="form-group">
          <label class="form-label">Магазин</label>

          <select
            v-model="form.shopId"
            class="form-input"
          >
            <option
              v-for="({ id, name }, index) in listShops"
              :key="`shop-${index}`"
              :value="id"
            >
              {{ name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label
            class="form-label"
            for="login"
          >
            Логин
          </label>

          <input
            id="login"
            v-model="form.login"
            class="form-input"
            type="text"
            placeholder="Введите логин"
            autocomplete="username"
          />
        </div>

        <div class="form-group">
          <label
            class="form-label"
            for="password"
          >
            Пароль
          </label>

          <div class="password-input">
            <input
              id="password"
              v-model="form.password"
              class="form-input"
              :type="getPasswordType"
              placeholder="Введите пароль"
              autocomplete="current-password"
            >

            <button
              type="button"
              class="password-toggle"
              @click="togglePassword"
            >
              {{ getPasswordToggleBtnText }}
            </button>
          </div>
        </div>

        <div
          v-if="error"
          class="auth-error"
        >
          {{ error }}
        </div>

        <button
          class="auth-submit"
          type="submit"
          :disabled="loading"
        >
          {{ getSubmitBtnText }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { LIST_SHOPS } from '@/constants/global'

export default {
  name: 'Login',

  data() {
    return {
      listShops: LIST_SHOPS,
      form: {
        login: '',
        password: '',
        shopId: LIST_SHOPS[0].id
      },
      showPassword: false,
      loading: false,
      error: '',
    }
  },
  computed: {
    ...mapGetters('user', ['isAuth']),
    getPasswordType () {
      return this.showPassword ? 'text' : 'password'
    },
    getPasswordToggleBtnText () {
      return this.showPassword ? 'Скрыть' : 'Показать'
    },
    getSubmitBtnText () {
      return this.loading ? 'Выполняется вход...' : 'Войти'
    }
  },
  created () {
    if (this.isAuth) {
      this.$router.push('/').catch()
    }
  },
  methods: {
    ...mapActions('user', ['auth']),
    async submit () {
      await this.$bus.emit('start-loader')

      const { data, error } = await this.auth(this.form)

      await this.$bus.emit('stop-loader')

      if (data?.id) {
        setTimeout(() => {
          this.$notify({
            type: 'success',
            title: 'Ура!',
            text: 'Вы успешно авторизованы!',
            clean: false,
            duration: 3000
          })
        }, 1000)

        await this.$nextTick()
        await this.$router.push('/').catch()

        return
      }

      this.$notify({
        type: 'error',
        title: 'Ошибка!',
        text: error.message,
        clean: false,
        duration: 3000
      })
    },
    togglePassword () {
      this.showPassword = !this.showPassword
    }
  }
}
</script>

<style lang="scss" scoped src="./style.scss" />